import React from 'react';

import {StepHeader} from 'src/components/step-header';

import {ENTITLEMENTS_SUB_TABS} from '../constants';
import {entitlementsSubTabTitle} from '../entitlements-subtab.module.styl';
import {EntitlementsTabBar} from '../entitlements-tabs';

import {DatasetEntitlementsTab} from './dataset-entitlements-tab';

type Props = {
    userId: number,
};

export const DatasetEntitlementsSubTab = ({userId}: Props) => (
    <>
        <EntitlementsTabBar
            userId={userId}
            activeSubTab={ENTITLEMENTS_SUB_TABS.DATASET_ENTITLEMENTS.name}
        />
        <div className={entitlementsSubTabTitle}>
            <StepHeader title={ENTITLEMENTS_SUB_TABS.DATASET_ENTITLEMENTS.caption}/>
        </div>
        <DatasetEntitlementsTab key={userId} userId={userId}/>
    </>
);
